export default __webpack_public_path__ + "static/media/googlePlayBadge.4487c2a7.png";